import { Component } from '@angular/core';
import { Events, ModalController } from 'ionic-angular';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { ExportServiceProvider } from '../../providers/export-service/export-service';
import { PriceListTableProvider } from '../../providers/price-list-table/price-list-table';
const DEFAULTVALUE = 0;
@Component({
  selector: 'project',
  templateUrl: 'project.html'
})
export class ProjectComponent {
  unitPrice: any;
  selectedRows: any = [];
  totalVal: any;
  newAttribute: any;
  headerValues = {
    buttonLabel: [{
      "name": "return",
      "action": 'return'
    }, {
      "name": "price list",
      "action": 'priceList'
    },{
      "name": "preview",
      "action": 'preview'
    }]
  };
  projectOptDes: any = '';
  constructor(public dataService: DataServiceProvider,public modalCtrl: ModalController,public events: Events,public exportService: ExportServiceProvider, public priceListTableService: PriceListTableProvider) {
    this.newAttribute = JSON.stringify({
      "qty": "",
      "description": "",
      "unitCost": "",
      "orMarkup": "",
      "unitPrice": "",
      "extendedPrice": ""
    });
  }
  ngOnInit() {
    this.dataService.goBack = 'PJT';
    this.dataService.sheetName = 'PJT';
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER', status: true, params: this.headerValues});
    if (localStorage.getItem('ProjectScreen')) {
      let projectData = localStorage.getItem('ProjectScreen')
      this.dataService.ProposalTable.projectScreen = JSON.parse(projectData);
    }
    var priceListData = JSON.parse(localStorage.getItem('Pricelist'));
    if (priceListData != null) {
      this.priceListTableService.priceList.TotalLabourRegularRate = priceListData.TotalLabourRegularRate;
    } else {
      this.priceListTableService.priceList.TotalLabourRegularRate = this.priceListTableService.priceList.defLabourRegularRate;
    }
    this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
       if(element.name == 'PJT'){
          this.projectOptDes = element.optionalDescription;
        }
      });
      this.bindHeaderValues();
  }
  ngAfterViewInit(){
        document.getElementById('pageWidth').scrollIntoView();
  }
  ngAfterViewChecked() {
    localStorage.setItem('ProjectScreen', JSON.stringify(this.dataService.ProposalTable.projectScreen));
  }
  bindHeaderValues(){
    let obj = {
      "oneTime" : 'One time Service',
      "monthly" : 'Product',
      "monthlyValue":  this.dataService.ProposalTable.projectScreen.Hslw.totalHslw,
      "OneTimeValue": this.dataService.ProposalTable.projectScreen.projectService.TotalProjectService
    }
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER_VALUE', params: obj});
  }
  changeDescription(i, event) {
    this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i]['description'] = event.target.value
  }
  qty(i, event) {
    if (event.target.value != '') {
      this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i]['qty'] = Math.round(event.target.value).toString();
      if (this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i]['unitPrice'] != '') {
        let unitPrice = parseFloat(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i]['unitPrice'].slice(1).replace(/  |,/gi,""));
        var extPrice = parseInt(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i]['qty']) * unitPrice;
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i]['extendedPrice'] = '$' + extPrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
    } else {
      this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i]['qty'] = '';
      this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i]['extendedPrice'] = '';
    }
    this.totalHslw();
  }

  unitCost(i, event) {
    if (event.target.value != '') {
      if (event.target.value.includes("$") == true) {
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitCost = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitCost = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
      let markupValue = 1 + (parseInt(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].orMarkup != '' ? this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].orMarkup.slice(0, -1) : this.dataService.ProposalTable.projectScreen.Hslw.markup.slice(0, -1)) / 100)
      this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitPrice = '$' + (parseFloat(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitCost.slice(1).replace(/  |,/gi,"")) * markupValue).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      if (this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].qty != '') {
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].extendedPrice = '$' + (parseFloat(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].qty) * parseFloat(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitPrice.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].extendedPrice = '';
      }
    } else {
      this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitCost = '';
      this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitPrice = '';
      this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].extendedPrice = '';
    }

    this.totalHslw();
  }
  ORmarkup(i, event) {
    if (event.target.value != '') {
      if (event.target.value.includes("%") == true) {
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].orMarkup = parseFloat(event.target.value.slice(0, -1)) + '%';
      } else {
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].orMarkup = parseFloat(event.target.value) + '%';
      }
      let markupValue = 1 + (parseInt(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].orMarkup != '' ? this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].orMarkup.slice(0, -1) : this.dataService.ProposalTable.projectScreen.Hslw.markup.slice(0, -1)) / 100)
      if(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitCost != ''){
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitPrice = '$' + (parseFloat(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitCost.slice(1).replace(/  |,/gi,"")) * markupValue).toFixed(2);
      }else{
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitPrice = '';
      }
      if (this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].qty != '') {
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].extendedPrice = '$' + (parseFloat(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].qty) * parseFloat(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitPrice.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].extendedPrice = '';
      }
    } else {
      this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].orMarkup = '';
      let markupValue = 1 + (parseInt(this.dataService.ProposalTable.projectScreen.Hslw.markup.slice(0, -1)) / 100)
      if (this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitCost != "") {
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitPrice = '$' + (parseFloat(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitCost.slice(1).replace(/  |,/gi,"")) * markupValue).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
      else {
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitPrice = '';
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].extendedPrice = '';
      }
      if (this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].qty != '') {
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].extendedPrice = '$' + (parseFloat(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].qty) * parseFloat(this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].unitPrice.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.dataService.ProposalTable.projectScreen.Hslw.hslwTable[i].extendedPrice = '';
      }
    }
    this.totalHslw();
  }
  descriptionFeesHourly(i, event) {
    this.dataService.ProposalTable.projectScreen.projectService.Hourly[i]['description'] = event.target.value
  }
  hours(i, event) {
    if (event.target.value != '') {
      this.dataService.ProposalTable.projectScreen.projectService.Hourly[i]['hours'] = parseFloat(event.target.value).toFixed(1);
      this.totalVal = parseFloat(this.dataService.ProposalTable.projectScreen.projectService.Hourly[i]['hours']) * parseFloat(this.priceListTableService.priceList.TotalLabourRegularRate.slice(1).replace(/  |,/gi,""))
    } else {
      this.dataService.ProposalTable.projectScreen.projectService.Hourly[i]['hours'] = '';
      this.totalVal = 0
    }
    if (this.dataService.ProposalTable.projectScreen.projectService.Hourly[i]['hours'] != '') {
        this.dataService.ProposalTable.projectScreen.projectService.Hourly[i]['total'] = '$' + this.totalVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    } else {
      this.dataService.ProposalTable.projectScreen.projectService.Hourly[i]['total'] = '';
    }
    this.totalProjectActivity();
  }
  courtestDiscount(event) {
    if (event.target.value != '') {
      if (event.target.value.includes("$") == true) {
        var courtesyDiscount = event.target.value.slice(1).replace(/  |,/gi,"");
      } else {
        courtesyDiscount = event.target.value;
      }
      this.dataService.ProposalTable.projectScreen.projectService.courtesyDiscount = '$' + parseFloat(courtesyDiscount).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    } else {
      this.dataService.ProposalTable.projectScreen.projectService.courtesyDiscount = '';
    }
    this.totalProjectActivity();
  }
  descriptionFlatFee(i, event) {
    this.dataService.ProposalTable.projectScreen.projectService.FlatFree[i]['description'] = event.target.value
  }
  flatFee(i, event) {
    if (event.target.value != '') {
      if (event.target.value.includes("$") == true) {
        var flat_fee = event.target.value.slice(1).replace(/  |,/gi,"");
      } else {
        flat_fee = event.target.value;
      }
      this.dataService.ProposalTable.projectScreen.projectService.FlatFree[i]['total'] = '$' + parseFloat(flat_fee).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    } else {
      this.dataService.ProposalTable.projectScreen.projectService.FlatFree[i]['total'] = '';
    }
    this.totalProjectActivity();
  }
  addRow() {
    let newRow = JSON.parse(this.newAttribute);
    this.dataService.ProposalTable.projectScreen.Hslw.hslwTable.push(newRow)
  }
  onMarkup(event) {
    if (event.target.value != '') {
      if (event.target.value.includes("%") == true) {
        this.dataService.ProposalTable.projectScreen.Hslw.markup = parseFloat(event.target.value.slice(0, -1)) + '%';
      } else {
        this.dataService.ProposalTable.projectScreen.Hslw.markup = parseFloat(event.target.value) + '%';
      }

      this.dataService.ProposalTable.projectScreen.Hslw.hslwTable.forEach(elem => {
        if (elem.unitCost != '' && elem.orMarkup == '') {
          let markupValue = 1 + (parseFloat(this.dataService.ProposalTable.projectScreen.Hslw.markup.slice(0, -1)) / 100)
          elem.unitPrice = '$' + (parseFloat(elem.unitCost.slice(1).replace(/  |,/gi,"")) * markupValue).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          if (elem.qty != "") {
            elem.extendedPrice = '$' + (parseFloat(elem.qty) * (parseFloat(elem.unitCost.slice(1).replace(/  |,/gi,"")) * markupValue)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          }
        }
      })
    }
    else {
      this.dataService.ProposalTable.projectScreen.Hslw.markup = '20%';
    }
    this.totalHslw();
  }
  totalHslw() {
    let sumArray = [];
    this.dataService.ProposalTable.projectScreen.Hslw.hslwTable.forEach(elem => {
      if (elem.extendedPrice == '') {
        var extPrice = DEFAULTVALUE
      } else {
        extPrice = parseFloat(elem.extendedPrice.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,""));
      }
      sumArray.push(extPrice)
    })
    var value = sumArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.projectScreen.Hslw.totalHslw = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }
    else{
      this.dataService.ProposalTable.projectScreen.Hslw.totalHslw = '';
    }
    this.bindHeaderValues();
  }
  totalProjectActivity() {
    let sumArray = [];
    this.dataService.ProposalTable.projectScreen.projectService.FlatFree.forEach(elem => {
      if (elem.total == '') {
        var flat_fee = DEFAULTVALUE
      } else {
        flat_fee = parseFloat(elem.total.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,""));
      }
      sumArray.push(flat_fee)
    })
    this.dataService.ProposalTable.projectScreen.projectService.Hourly.forEach(elem => {
      if (elem.total == '') {
        var total = DEFAULTVALUE
      } else {
        total = parseFloat(elem.total.slice(1).replace(/  |,/gi,"").replace(/  |,/gi,""));
      }
      sumArray.push(total)
    })
    var totalVal = sumArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if (this.dataService.ProposalTable.projectScreen.projectService.courtesyDiscount != '') {
      var value = totalVal - parseFloat(this.dataService.ProposalTable.projectScreen.projectService.courtesyDiscount.slice(1).replace(/  |,/gi,""));
    } else {
      value = totalVal;
    }
    if (value != 0) {
     
        this.dataService.ProposalTable.projectScreen.projectService.TotalProjectService = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    } else {
      this.dataService.ProposalTable.projectScreen.projectService.TotalProjectService = '';
    }
    this.bindHeaderValues();
  }
  checkboxClick(i, event) {
    if (event.target.checked == true) {
      this.selectedRows.push(i);
    } else {
      let index = this.selectedRows.indexOf(i);
      this.selectedRows.splice(index, 1);
    }
  }
  deleteRow() {
    for (let i=this.selectedRows.length-1;i>=0;i--){
      this.dataService.ProposalTable.projectScreen.Hslw.hslwTable.splice(this.selectedRows[i],1)
    }
    this.selectedRows = [];
    this.totalHslw();
  }
  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/components/project/project.ts